import { render, staticRenderFns } from "./NordicWalking.vue?vue&type=template&id=9cdfaa62"
import script from "./NordicWalking.vue?vue&type=script&lang=js"
export * from "./NordicWalking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports